import React, { useEffect, useRef, useState } from "react";
import avatar from "assets/images/avatar_2.jpeg";
import Signup from "components/Signup/Signup";
import { ReactComponent as Logo } from "assets/images/house_scan_logo_white.svg";
import useAuth from "hooks/useAuth";
import { getColorFromUsername } from "utils/commonUtils";
import { useOrganiseList } from "context/OrganiseListContext";
import searchPageImage from "assets/images/3rd.webp";

const Profile = () => {
  const { user, signOut, updatePassword, changeAvatar } = useAuth();
  const { clearOrganiseList } = useOrganiseList();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const fileInputRef = useRef(null);

  // Initally set the user data
  useEffect(() => {
    if (user) {
      setFirstName(user.firstName);
      setLastName(user.lastName);
      setEmail(user.email);
    }
  }, [user]);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      await changeAvatar(file);
    }
  };

  const handlePassword = async () => {
    await updatePassword(email);
  };

  const handleLogout = async () => {
    await clearOrganiseList();
    await signOut();
  };

  return (
    <div className="bg-white h-auto rounded-[10px] pl-[19px] sm:pl-[28px] pt-[27px] pr-[19px] sm:pr-[28px] pb-[12px] sm:pb-[46px]">
      {user ? (
        <>
          <h2 className="hidden sm:block input-label">Profilo</h2>
          <div className="sm:mt-[27px] flex items-center flex-col sm:flex-row sm:space-x-[24px]">
            {user?.avatar ? (
              <img
                src={user.avatar}
                alt="avatar"
                className="border-[2px] border-primary w-[133px] sm:w-[185px] sm:min-w-[185px] h-[133px] sm:h-[185px] rounded-[10px] object-cover p-[2px]"
              />
            ) : (
              <div className="border-[2px] border-primary w-[133px] sm:w-[185px] sm:min-w-[185px] h-[133px] sm:h-[185px] rounded-[10px] p-[2px]">
                <div
                  style={{
                    backgroundColor: getColorFromUsername(user.firstName),
                  }}
                  className="flex items-center justify-center font-medium text-[90px] text-white w-full h-full rounded-[8px] "
                >
                  {user?.firstName?.charAt(0)?.toUpperCase()}
                </div>
              </div>
            )}

            <div>
              <h2 className="input-label hidden sm:block">Profilo</h2>
              <p className="text-[16px] mt-[17px] sm:mt-2 font-normal text-center sm:text-start leading-[1.2] text-[#373C47]">
                Questa foto verrà mostrata quando verrai aggiunto a una lista
                condivisa
              </p>
              {/* Hidden file input */}
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                className="hidden"
                accept="image/*"
              />

              <button
                onClick={() => fileInputRef.current.click()}
                className="hidden sm:block text-[16px] font-bold text-primary leading-normal mt-[71px]"
              >
                CARICA IMMAGINE
              </button>
            </div>
          </div>
          <form className=" mt-[17px] sm:mt-[38px]">
            <div className="flex flex-col space-y-[22px]">
              <div className="flex items-center xs:space-x-[16px]">
                <label className="input-label w-[162px] hidden xs:block">
                  Nome
                </label>
                <input
                  readOnly
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="update-input"
                />
              </div>
              <div className="flex items-center xs:space-x-[16px]">
                <label className="input-label w-[162px] hidden xs:block">
                  Cognome
                </label>
                <input
                  readOnly
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  className="update-input"
                />
              </div>
              <div className="flex items-center xs:space-x-[16px]">
                <label className="input-label w-[162px] hidden xs:block">
                  Email
                </label>
                <div className="update-input">
                  <input
                    readOnly
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full h-full bg-transparent outline-none flex-1"
                  />
                </div>
              </div>
              <div className="flex items-center xs:space-x-[16px]">
                <label className="input-label w-[162px] hidden xs:block">
                  Password
                </label>
                <div className="update-input">
                  <input
                    readOnly
                    placeholder="******"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full h-full bg-transparent outline-none flex-1 placeholder:text-black"
                  />
                  <h3
                    onClick={handlePassword}
                    className="hidden sm:block text-[16px] cursor-pointer font-bold text-primary mr-[6.6px] ml-[16px]"
                  >
                    CAMBIA
                  </h3>
                </div>
              </div>
            </div>
          </form>
          <button className="block sm:hidden w-full mx-auto text-[16px] font-bold text-primary leading-normal mt-[12px]">
            CAMBIA
          </button>

          <h2 className="text-[24px] font-normal text-center mx-auto mt-8">
            Vuoi disconnetterti dall'account?{" "}
            <span
              onClick={handleLogout}
              className="cursor-pointer text-red-500"
            >
              Logout
            </span>
          </h2>
        </>
      ) : (
        <>
          <div className="lg:hidden pb-[11px] xs:min-w-[319px] md:min-w-full sm:min-w-[500px] h-[149px] sm:h-[200px] overflow-hidden w-full">
            <div className="overflow-hidden rounded-[13px] h-full w-full relative">
              {/* <Logo className="w-[115px] object-contain h-[26px] pt-1 " /> */}
              <img
                className="absolute -top-[3px] left-0 right-0 bottom-0"
                src={searchPageImage}
                alt=""
              />
            </div>
          </div>
          <Signup isSettings={true} />
        </>
      )}
    </div>
  );
};

export default Profile;
